module.exports = __webpack_public_path__ + "static/img/m6.c79b41e.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/iot/m6.png
// module id = biso
// module chunks = 0